import React from "react";

import { marked } from "marked";

import { linkClasses } from "@busbud/horizon";

interface Props {
  source: string | undefined | null;
  className?: string | undefined;
  target_blank_anchor?: boolean;
  Component?: React.ElementType<React.HTMLAttributes<HTMLElement>>;
}

const getLinkRenderer = (target_blank_anchor?: boolean) => {
  const renderer = new marked.Renderer();
  renderer.link = function (href: string, title: string, text: string) {
    const link = marked.Renderer.prototype.link.call(this, href, title, text);
    return link.replace(
      "<a",
      `<a class='${linkClasses.root({ disableUnderline: true, disableVisitedStyles: true, isMonochrome: false })}' ${target_blank_anchor ? "rel='noopener' target='_blank'" : ""}`
    );
  };
  return renderer;
};

const sanitizeSource = (source: string | undefined | null | object): string => {
  if (typeof source !== "string") {
    return "";
  }
  return source;
};

export const Markdown: React.FC<Props> = props => {
  const {
    source,
    className,
    target_blank_anchor = false,
    Component = "div"
  } = props;

  const markup = {
    __html: marked(sanitizeSource(source), {
      renderer: getLinkRenderer(target_blank_anchor)
    })
  };

  return <Component className={className} dangerouslySetInnerHTML={markup} />;
};
